<!-- UI minimaliste “J-10” -->
<div class="wallet-box">
      <button class="flex items-center gap-1 px-3 py-1 rounded-full text-xs border shadow-sm font-medium transition"
         (click)="takerAddress ? disconnectWallet() : connectWallet()"
         [ngClass]="isDarkMode()
         ? (takerAddress
             ? 'text-white/80 bg-white/5 border-white/10 hover:bg-white/10 focus-visible:ring-2 focus-visible:ring-white/20'
: 'text-blue-400 bg-blue-400/10 border-white/10')
         : (takerAddress
             ? 'text-emerald-700 bg-emerald-50/60 border-emerald-200 hover:bg-emerald-50'
             : 'text-gray-900 bg-white/80 border-purple-200 hover:bg-white')">
   <svg *ngIf="!takerAddress" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
     <path d="M21 8v8a3 3 0 01-3 3H6a3 3 0 01-3-3V8a3 3 0 013-3h12a3 3 0 013 3z" />
     <path d="M21 8H3m15 5h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2" />
   </svg>
   <svg *ngIf="takerAddress" class="w-3.5 h-3.5"
        [ngClass]="isDarkMode() ? 'text-green-400' : 'text-emerald-500'"
        fill="none" stroke="currentColor" viewBox="0 0 24 24">
     <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
   </svg>
   <span class="truncate max-w-[5rem]">
     {{ takerAddress ? getFormattedAddress(takerAddress) : '0xbb84…dcf5' }}
   </span>
 </button>
</div>
